import { usePaywallCustomizationContext } from "../PaywallCustomizationProvider";
import { Benefit } from "./Benefit";
import { Title } from "./Title";

export const Benefits = () => {
  const { paywallCustomization } = usePaywallCustomizationContext();

  const {
    enabled: isBenefitEnabled,
    benefits,
    title,
  } = paywallCustomization?.benefit_properties || {
    enabled: false,
    benefits: [],
  };

  if (!isBenefitEnabled) {
    return null;
  }

  return (
    <div className="flex flex-col gap-y-2">
      <Title title={title} />
      <div className="flex flex-col gap-y-2" data-testid="benefits-container">
        {benefits.map(benefit => (
          <Benefit key={benefit.id} {...benefit} />
        ))}
      </div>
    </div>
  );
};
